<script>

export default {
    name: 'CarImage1'
}

</script>

<template>
    <div class="main">

        <div class="card">
            <p class="legenda">SEDE FABRIL</p>

            <ul >
                <p class="subtext">CAPACIDADE DE 85 TON/MÊS.</p>
            <li class="text">CAPACIDADE DE ELEVAÇÃO, PÓRTICO 5 TON, PÓRTICO 3 TON.</li>
            <li class="text">ÁREA FABRIL: 2.900m²</li>
            <li class="text">ÁREA DE FABRICAÇÃO: 2000M²</li>
            <li class="text">ÁREA DE USINAGEM: 900M²</li>
            <li class="text">ÁREA BASE/ ALMOXARIFADO/ SALAS: 490M²</li>
            </ul>

        </div>


    </div>
</template>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Staatliches&display=swap');

@media (max-width: 900px) {}
.main {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100vw;
    }

    .card {
        width: 100%;
        background-image: url('../assets/imagens/carrossel1.jpg');
        background-size: cover;
        background-repeat: no-repeat;
        position: relative;
        background-position: center;
        color: #fff;
    }

    .legenda {
        margin-top: 0%;
        font-size: 1rem;
        font-weight: bold;
        margin-left: 5%;
        text-shadow: 0rem 0rem 1rem #000
    }
    ul{
        display: flex;
        flex-direction: column;
        align-items: baseline;
        justify-content: center;
        background-color: #f3f3f38a;
        color: #fff;
        width: 50%;
        border-radius: 5px;
        padding: 1%;
        box-shadow: 0rem 0rem 1rem 0.1rem #3778da;
    }
    .subtext{
        font-size: 0.8rem;
        margin-left: 02%;
        margin-bottom: 1rem;
    }
    .text{
        font-size: 0.6rem;
    }
@media (min-width: 901px) {
    .main {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100vw;
        height: 80vh;

    }

    .card {
        width: 100%;
        height: 100%;
        background-image: url('../assets/imagens/carrossel1.jpg');
        background-size: cover;
        background-repeat: no-repeat;
        position: relative;
        background-position: center;
        color: #fff;
    }

    .legenda {
        margin-top: 3%;
        font-size: 3.5rem;
        font-weight: bold;
        margin-left: 10%;
        text-shadow: 0rem 0rem 1rem #000
    }
    ul{
        display: flex;
        flex-direction: column;
        align-items: baseline;
        justify-content: center;
        background-color: #0e0d0dc7;
        color: #fff;
        width: 65%;
        margin-top: 2%;
        margin-left: 10%;
        border-radius: 5px;
        padding: 2%;
        padding-left: 4%;
        box-shadow: 0rem 0rem 1rem 0.1rem #3778da;
    }
    .subtext{
        font-size: 2rem;
        margin-left: 02%;
        margin-bottom: 1rem;
    }
    .text{
        font-size: 1.5rem;
        margin: 0.2rem 0rem;
    }
}
</style>